import type { HttpClient } from '@angular/common/http';
import type { Listing } from '@thevillages/schemas';

import { RedirectCommand, type Router } from '@angular/router';
import { catchError, map, type Observable, of } from 'rxjs';

import { Environment } from '../../../environments/environment';

export function GetByULIKey(
  httpClient: HttpClient,
  router: Router,
  id: string,
  token?: string,
): Observable<Listing | RedirectCommand> {
  // First attempt to fetch the listing using the primary endpoint.
  return primary(httpClient, router, id, token).pipe(
    // If the primary endpoint fails, attempt to fetch the listing using the fallback endpoint.
    catchError(() => fallback(httpClient, router, id, token)),
  );
}

function fallback(
  httpClient: HttpClient,
  router: Router,
  id: string,
  token?: string,
): Observable<Listing | RedirectCommand> {
  return httpClient
    .get<Listing>(`https://api.v2.thevillages.com/homes/listings/view/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : 'Basic 6501b52adbac5a809447da4f',
      },
    })
    .pipe(
      map((listings) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This is a fallback endpoint, so we need to check if the listings are null or undefined.
        if (!listings) {
          // Redirect if no listings are found.
          return new RedirectCommand(router.parseUrl('/'));
        }

        return listings;
      }),
      catchError(() => {
        // Redirect if the route was not found or if there was an error fetching the listing.
        return of(new RedirectCommand(router.parseUrl('/')));
      }),
    );
}

function primary(
  httpClient: HttpClient,
  router: Router,
  id: string,
  token?: string,
): Observable<Listing> {
  return httpClient
    .get<Listing[]>(`${Environment.apiUrl}/listings?uliKey=${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : 'Basic 6501b52adbac5a809447da4f',
      },
    })
    .pipe(
      map((listings) => {
        // If no listings are found, return an error to trigger the fallback.
        if (!listings.length) {
          throw new Error('No listings found.');
        }

        return listings[0];
      }),
      catchError(() => {
        // Return an error to trigger the fallback if the route was not found or if there was an error fetching the listing.
        throw new Error('Error fetching listings.');
      }),
    );
}
